import { Component, OnInit } from '@angular/core';
import { FondoDenominacion } from 'src/app/models/dash';
import { AsignarFondoService } from 'src/app/services/asignar-fondo.service';
import { selectUser } from 'src/app/state/selectors/user.selectors';
import { Store } from '@ngrx/store';
import { AppState } from 'src/app/state/app.state';
import { NgxUiLoaderService } from 'ngx-ui-loader';
@Component({
  selector: 'app-confirmar-fondo-inicial',
  templateUrl: './confirmar-fondo-inicial.component.html',
  styleUrls: ['./confirmar-fondo-inicial.component.scss']
})
export class ConfirmarFondoInicialComponent implements OnInit {

  idInputElemet = '';
  fondoInicial=0;
  fondoValido:boolean;
  tieneFondoAsignado=false;


  denominacionFormato: FondoDenominacion[] = [];
  user:any
  carril:any

  constructor(
    private store: Store<AppState>,
    private ngxUiLoaderService: NgxUiLoaderService,
    public asignarFondoService: AsignarFondoService,
    ) { }

  ngOnInit(): void {
    this.ngxUiLoaderService.start()
    this.store.select(selectUser).subscribe(user => this.user = user);
    this.asignarFondoService.getFondoDenominacion(this.user.caseta_usuario[0].id).then(() => {
      this.denominacionFormato = this.asignarFondoService.fondoDenominacion.slice(0, 10).reverse();
    });
    this.asignarFondoService.getFondoParaConfirmar(this.user.id).subscribe((data) => {
      this.fondoInicial=0
      this.carril=data.carril
      let fondos=data.fondoPorConfirmar;
      if(fondos.length>0){
        fondos.forEach(fondo => {
          this.tieneFondoAsignado=true
          document.getElementById("cantidad-"+fondo.id_denominacion).setAttribute("value", fondo.cantidad + '');
          //monto
          var monto=Number((document.getElementById("monto-"+fondo.id_denominacion) as HTMLInputElement).value)
          //total
          document.getElementById("total-"+fondo.id_denominacion).setAttribute("value", monto*fondo.cantidad + '')
          this.fondoInicial+=monto*fondo.cantidad
        });
      }else{
        this.tieneFondoAsignado=false
      }
    });
    this.ngxUiLoaderService.stop()
  }
  confirmarFondoInicial(){
    this.asignarFondoService.confirmarFondoInicial(this.user.id).subscribe(data=>function(){
    })
      this.tieneFondoAsignado=false;
  }
}
